export const APPT_STATUS = {
	OPEN: 1,
	CANCELLED: 2,
	SCHEDULED: 3,
	ACKNOWLEDGED: 4,
	DISPATCHED: 5,
	ON_SITE: 6,
	TRAVEL: 7,
	COMPLETED: 8,
	IN_JEOPARDY: 9,
	INCOMPLETE: 10,
	REJECTED: 11,
	TENTATIVE: 12
};
Object.freeze(APPT_STATUS);

export const REQUEST_STATUS = {
	NEW: 1,
	CANCELLED: 2,
	COMPLETE: 3,
	POTENTIAL: 4,
	ON_HOLD: 5,
	DATA_REVIEW: 6,
	SCHEDULED: 7,
	ATL_REVIEW: 8
};
Object.freeze(REQUEST_STATUS);

export const PHONE_TYPES = [
	'work',
	'mobile',
	'home',
	'other'
];

export const HOME_ROUTE = '/';
export const LOG_IN_ROUTE = '/log-in';
export const CONTACT_US_ROUTE = '/contact-us';
export const GET_ASSISTANCE_ROUTE = '/get-assistance';
export const CONTACT_COMPANY_ROUTE = '/contact-finance-company';
export const EXISTING_APPOINTMENT_ROUTE = '/existing-appointment';
export const PRIVACY_ROUTE = '/privacy';
export const TERMS_ROUTE = '/terms';
export const ACCOUNT_ROUTE = '/account';
export const CONDITION_ROUTE = '/condition';
export const CONTACT_ROUTE = '/contact';
export const LOCATION_ROUTE = '/location';
export const SCHEDULE_ROUTE = '/schedule';
export const REVIEW_ROUTE = '/review';
export const CONFIRMATION_ROUTE = '/confirmation';
export const ERROR_ROUTE = '/error';

export const LANGUAGES = [
	{ 'value': 'EN', 'display': 'English' },
	{ 'value': 'ES', 'display': 'Español' }
];

export const LOCATION_TYPES = {
	'EN': [
		{ 'value': 'home', 'display': 'Home' },
		{ 'value': 'work', 'display': 'Work' },
		{ 'value': 'dealer', 'display': 'Dealership' },
		{ 'value': 'other', 'display': 'Other' }
	],
	'ES': [
		{ 'value': 'home', 'display': 'Casa' },
		{ 'value': 'work', 'display': 'Trabajo' },
		{ 'value': 'dealer', 'display': 'Concesión' },
		{ 'value': 'other', 'display': 'Otro' }
	]
};

export const PREFERRED_CONTACT_METHODS = {
	'EN': {
		'label': 'Preferred contact method',
		'options': [
			{
				'value': 'phone',
				'display': 'Phone'
			},
			{
				'value': 'sms',
				'display': 'SMS Text'
			},
			{
				'value': 'email',
				'display': 'Email'
			}
		]
	},
	'ES': {
		'label': 'Método de contacto preferido',
		'options': [
			{
				'value': 'phone',
				'display': 'Teléfono'
			},
			{
				'value': 'sms',
				'display': 'Mensaje de texto'
			},
			{
				'value': 'email',
				'display': 'Correo electrónico'
			}
		]
	}
};

export const COUNTRIES = [
	{
		'value': 'US',
		'display': 'United States of America',
		'states': [
			{ 'value': 'AL', 'display': 'Alabama' },
			{ 'value': 'AK', 'display': 'Alaska' },
			{ 'value': 'AZ', 'display': 'Arizona' },
			{ 'value': 'AR', 'display': 'Arkansas' },
			{ 'value': 'CA', 'display': 'California' },
			{ 'value': 'CO', 'display': 'Colorado' },
			{ 'value': 'CT', 'display': 'Connecticut' },
			{ 'value': 'DE', 'display': 'Delaware' },
			{ 'value': 'DC', 'display': 'District of Columbia' },
			{ 'value': 'FL', 'display': 'Florida' },
			{ 'value': 'GA', 'display': 'Georgia' },
			{ 'value': 'HI', 'display': 'Hawaii' },
			{ 'value': 'ID', 'display': 'Idaho' },
			{ 'value': 'IL', 'display': 'Illinois' },
			{ 'value': 'IN', 'display': 'Indiana' },
			{ 'value': 'IA', 'display': 'Iowa' },
			{ 'value': 'KS', 'display': 'Kansas' },
			{ 'value': 'KY', 'display': 'Kentucky' },
			{ 'value': 'LA', 'display': 'Louisiana' },
			{ 'value': 'ME', 'display': 'Maine' },
			{ 'value': 'MD', 'display': 'Maryland' },
			{ 'value': 'MA', 'display': 'Massachusetts' },
			{ 'value': 'MI', 'display': 'Michigan' },
			{ 'value': 'MN', 'display': 'Minnesota' },
			{ 'value': 'MS', 'display': 'Mississippi' },
			{ 'value': 'MO', 'display': 'Missouri' },
			{ 'value': 'MT', 'display': 'Montana' },
			{ 'value': 'NE', 'display': 'Nebraska' },
			{ 'value': 'NV', 'display': 'Nevada' },
			{ 'value': 'NH', 'display': 'New Hampshire' },
			{ 'value': 'NJ', 'display': 'New Jersey' },
			{ 'value': 'NM', 'display': 'New Mexico' },
			{ 'value': 'NY', 'display': 'New York' },
			{ 'value': 'NC', 'display': 'North Carolina' },
			{ 'value': 'ND', 'display': 'North Dakota' },
			{ 'value': 'OH', 'display': 'Ohio' },
			{ 'value': 'OK', 'display': 'Oklahoma' },
			{ 'value': 'OR', 'display': 'Oregon' },
			{ 'value': 'PA', 'display': 'Pennsylvania' },
			{ 'value': 'PR', 'display': 'Puerto Rico' },
			{ 'value': 'RI', 'display': 'Rhode Island' },
			{ 'value': 'SC', 'display': 'South Carolina' },
			{ 'value': 'SD', 'display': 'South Dakota' },
			{ 'value': 'TN', 'display': 'Tennessee' },
			{ 'value': 'TX', 'display': 'Texas' },
			{ 'value': 'UT', 'display': 'Utah' },
			{ 'value': 'VT', 'display': 'Vermont' },
			{ 'value': 'VI', 'display': 'Virgin Islands, U.S.' },
			{ 'value': 'VA', 'display': 'Virginia' },
			{ 'value': 'WA', 'display': 'Washington' },
			{ 'value': 'WV', 'display': 'West Virginia' },
			{ 'value': 'WI', 'display': 'Wisconsin' },
			{ 'value': 'WY', 'display': 'Wyoming' }
		]
	},
	{
		'value': 'MX',
		'display':
		'Mexico',
		'states': [
			{ 'value': 'AGU', 'display': 'Aguascalientes' },
			{ 'value': 'BCN', 'display': 'Baja California' },
			{ 'value': 'BCS', 'display': 'Baja California Sur' },
			{ 'value': 'CAM', 'display': 'Campeche' },
			{ 'value': 'COA', 'display': 'Coahuila' },
			{ 'value': 'COL', 'display': 'Colima' },
			{ 'value': 'CHP', 'display': 'Chiapas' },
			{ 'value': 'CHH', 'display': 'Chihuahua' },
			{ 'value': 'DIF', 'display': 'Distrito Federal' },
			{ 'value': 'DUR', 'display': 'Durango' },
			{ 'value': 'GUA', 'display': 'Guanajuato' },
			{ 'value': 'GRO', 'display': 'Guerrero' },
			{ 'value': 'HID', 'display': 'Hidalgo' },
			{ 'value': 'JAL', 'display': 'Jalisco' },
			{ 'value': 'MEX', 'display': 'México' },
			{ 'value': 'MIC', 'display': 'Michoacán' },
			{ 'value': 'MOR', 'display': 'Morelos' },
			{ 'value': 'NAY', 'display': 'Nayarit' },
			{ 'value': 'NLE', 'display': 'Nuevo León' },
			{ 'value': 'OAX', 'display': 'Oaxaca' },
			{ 'value': 'PUE', 'display': 'Puebla' },
			{ 'value': 'QUE', 'display': 'Querétaro' },
			{ 'value': 'ROO', 'display': 'Quintana Roo' },
			{ 'value': 'SLP', 'display': 'San Luis Potosí' },
			{ 'value': 'SIN', 'display': 'Sinaloa' },
			{ 'value': 'SON', 'display': 'Sonora' },
			{ 'value': 'TAB', 'display': 'Tabasco' },
			{ 'value': 'TAM', 'display': 'Tamaulipas' },
			{ 'value': 'TLA', 'display': 'Tlaxcala' },
			{ 'value': 'VER', 'display': 'Veracruz' },
			{ 'value': 'YUC', 'display': 'Yucatán' },
			{ 'value': 'ZAC', 'display': 'Zacatecas' }
		]
	},

	{
		'value': 'CA',
		'display': 'Canada',
		'states': [
			{ 'value': 'AB', 'display': 'Alberta' },
			{ 'value': 'BC', 'display': 'British Columbia' },
			{ 'value': 'MB', 'display': 'Manitoba' },
			{ 'value': 'NB', 'display': 'New Brunswick' },
			{ 'value': 'NL', 'display': 'Newfoundland and Labrador' },
			{ 'value': 'NS', 'display': 'Nova Scotia' },
			{ 'value': 'ON', 'display': 'Ontario' },
			{ 'value': 'PE', 'display': 'Prince Edward Island' },
			{ 'value': 'QC', 'display': 'Quebec' },
			{ 'value': 'SK', 'display': 'Saskatchewan' },
			{ 'value': 'NT', 'display': 'Northwest Territories' },
			{ 'value': 'NU', 'display': 'Nunavut' },
			{ 'value': 'YT', 'display': 'Yukon' }
		]
	}
];
Object.freeze(COUNTRIES);
